// src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Box, Typography, Button, CssBaseline } from '@mui/material'; // Import Material UI components

const NotFoundPage = () => {
  return (
      <Container component="main" maxWidth="sm"> {/* Container with maxWidth 'sm' */}
      <CssBaseline /> {/* Optional: CssBaseline for consistent styling */}
      <Box
          sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
          }}
      > {/* Flexbox layout for centering content */}
          <Typography component="h1" variant="h4" align="center" sx={{ mb: 2, color: 'error.main' }}> {/* Title with error color */}
              404 - 页面未找到
          </Typography>
          <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mb: 4 }}> {/* Subtitle */}
              抱歉，您访问的页面不存在。
          </Typography>
          <Button variant="contained" component={Link} to="/"> {/* Button to Homepage */}
              返回首页
          </Button>
      </Box>
  </Container>
  );
};

export default NotFoundPage;
